/**
 * initialize swiper slider for products slider on homepage
 */

import Swiper from "../../../scripts/dependencies/swiper.min.js";

// References: https://medium.com/@networkaaron/swiper-how-to-destroy-swiper-on-min-width-breakpoints-a947491ddec8
var breakpoint = window.matchMedia("(min-width: 992px)");
var valuePropositionSlider = void 0;

export function init() {
    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);
    // kickstart
    breakpointChecker();
}

var breakpointChecker = function() {
    // For larger screen size
    if (breakpoint.matches === true) {
        // Disable slider
        if (valuePropositionSlider !== undefined)
            valuePropositionSlider.destroy(true, true);
        // or/and do nothing
        return;
    } else if (breakpoint.matches === false) {
        return enableSlider();
    }
};

var enableSlider = function() {
    valuePropositionSlider = new Swiper("#value-propositions", {
        loop: true,
        speed: 1000,
        slidesPerView: "auto",
        // centeredSlides: true,
        a11y: true,
        autoplay: {
            delay: 4000
        }
    });
};
